import React from 'react'

interface PartnerProps {
    name: string
    logo: string
    url: string
}

const PartnerCard: React.FC<PartnerProps> = ({ name, logo, url }) => (
    <div className="w-80">
        <div className="flex flex-col items-center text-center bg-cyan-100 rounded-2xl shadow-md p-6">
            <div className=" h-24 mb-4">
                <img src={logo} alt={`${name} Logo`} className="w-full h-full object-contain" />
            </div>

            <a href={url} target="_blank" rel="noopener noreferrer">
                <h3 className="text-xl font-semibold text-cyan-900 mb-2">{name}</h3>
            </a>
        </div>
    </div>
)

const OurPartners: React.FC = () => {
    return (
        <section className="bg-white py-12 px-6">
            <h2 className="text-3xl font-bold text-center mb-8">Our Partners</h2>

            {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto"> */}
            <div className="flex flex-col sm:flex-row sm:flex-wrap justify-center items-center gap-8 max-w-6xl mx-auto">
                <PartnerCard
                    name="Thurrock Lifestyle Solutions"
                    logo="assets/Thurrock-Lifestyle-Solutions_logo.jpg"
                    url="http://www.choiceandcontrol.co.uk/"
                />
                <PartnerCard
                    name="Rates Ford"
                    logo="assets/ratesford_logo-v2.png"
                    url="https://www.rates.co.uk/"
                />
                <PartnerCard
                    name="Griffin The Property People"
                    logo="assets/griffin_residential_grays_logo.jpg"
                    url="https://www.griffingroup.co.uk/"
                />
                <PartnerCard
                    name="Decathlon"
                    logo="assets/decathlon-logo-wide.jpg"
                    url="https://www.decathlon.co.uk/"
                />
            </div>
        </section>
    )
}

export default OurPartners